import builder from '../builder';
import CashPaymentCoin from '../../streamline-icons/light/cash-payment-coin.svg';

export default builder('IconCashPaymentCoinLight', CashPaymentCoin);
